{
  "rangeOverflow": "Vrednost mora da bude {maxValue} ili starija.",
  "rangeReversed": "Datum početka mora biti pre datuma završetka.",
  "rangeUnderflow": "Vrednost mora da bude {minValue} ili novija.",
  "unavailableDate": "Izabrani datum nije dostupan."
}
